const { h, render, Component } = require('preact');
const StatusInfo = require('./status_info')
const TradeInStatus = require('./trade_in_status')
const GiftStatus = require('../../containers/status/gift_status')

  class RegularOrderStatus extends Component {
    constructor() {
      super();
    }

    render({order}) {
      return (<div>
                <StatusInfo landingView = {this.props.landingView} order={order}/>
                <TradeInStatus landingView = {this.props.landingView} order={order} />
                <GiftStatus landingView = {this.props.landingView} order={order} />
              </div>)
    }

}

module.exports = RegularOrderStatus
